import { useInitDataRaw } from '@telegram-apps/sdk-react'
export const useTgUserInfo = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = useInitDataRaw() as any
  console.log(data?.result?.initData, 'data?.result?.initData')

  return data?.result?.initData?.user
}
